import BarChartRounded from "@mui/icons-material/BarChartRounded";
import LockOutlined from "@mui/icons-material/LockOutlined";
import QrCodeScanner from "@mui/icons-material/QrCodeScanner";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router";
import { statusToPill } from "../../../moment-card/utils";
import { DuplicateSurveyButton } from "../../../survey/components/duplicate-survey-button";
import { RecentlyEditedRow, RowDetail } from "./recently-edited-row";

import type { SeverityPillColor } from "../../../generic/components/severity-pill";
import type { RecentlyEditedItem } from "../../hooks/use-recently-edited";
import type { FC } from "react";

type SurveyStatus = NonNullable<RecentlyEditedItem["survey_status"]>;

// As statusToPill colours a Communication's: a closed Survey is done, like a finished one.
const statusColours: Record<SurveyStatus, SeverityPillColor> = {
  draft: "warning",
  active: "error",
  closed: "info",
};

const ResponseCount: FC<{ survey: RecentlyEditedItem }> = ({ survey }) => {
  const count = survey.response_count;
  if (count === null) return null;
  const label = `${count} ${count === 1 ? "response" : "responses"}`;
  if (count === 0) return <RowDetail>{label}</RowDetail>;
  return (
    <RowDetail>
      <Link
        component={RouterLink}
        to={`/listen/survey/${survey.id}/results`}
        underline="hover"
        data-analytics-id="dashboard-recently-edited-survey-results"
      >
        {label}
      </Link>
    </RowDetail>
  );
};

/** A Survey in the feed: how it's set up, and its responses where the user can see them. */
export const SurveyRow: FC<{ survey: RecentlyEditedItem }> = ({ survey }) => (
  <RecentlyEditedRow
    media={<BarChartRounded color="primary" data-testid="survey-icon" sx={{ fontSize: 48 }} />}
    title={survey.title}
    href={`/listen/survey/${survey.id}`}
    analyticsId="dashboard-recently-edited-survey"
    pill={survey.survey_status && statusToPill(survey.survey_status, statusColours)}
    action={<DuplicateSurveyButton id={survey.id} title={survey.title} />}
    details={
      <>
        {survey.confidential && <RowDetail icon={<LockOutlined />}>Confidential</RowDetail>}
        {survey.generic_links_enabled && (
          <RowDetail icon={<QrCodeScanner />}>Generic link enabled</RowDetail>
        )}
        <ResponseCount survey={survey} />
      </>
    }
  />
);
